export const permissions = [
  {
    "page_name": "dashboard",
    "page_access": ['manage']
  },
  {
    "page_name": "settings",
    "page_access": ['manage']
  },
  {
    "page_name": "users",
    "page_access": ['manage']
  },
  {
    "page_name": "servers",
    "page_access": ['manage']
  },
  {
    "page_name": "programmers",
    "page_access": ['manage']
  },
  {
    "page_name": "designers",
    "page_access": ['manage']
  },
  {
    "page_name": "beta_testers",
    "page_access": ['manage']
  },
  {
    "page_name": "videos",
    "page_access": ['manage']
  },
  {
    "page_name": "content_creators",
    "page_access": ['manage']
  },
  {
    "page_name": "shop",
    "page_access": ['manage']
  },
  {
    "page_name": "transactions",
    "page_access": ['manage']
  },
  {
    "page_name": "services",
    "page_access": ['manage']
  }
]